import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./lpr-management.component.html?ngResource";
import { Component, ViewEncapsulation, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { SplitterModule } from 'primeng/splitter';
import { LPRWorkflowListComponent } from './lpr-workflow-list/lpr-workflow-list.component';
import { LprWorkflowComponent } from './lpr-workflow/lpr-workflow.component';
import { BehaviorSubject, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { LprWorkflow, LPRManagementService } from 'src/ng-app/features/lpr-management';
import { ToastModule } from 'primeng/toast';
let LPRManagementComponent = class LPRManagementComponent {
    LprManagementService = inject(LPRManagementService);
    #destroy$ = new Subject();
    _expandOrCollapseAll$ = new BehaviorSubject(false);
    expandOrCollapseAll$;
    orgForNewWorkflow = null;
    ngOnInit() {
        this.expandOrCollapseAll$ = new BehaviorSubject(this._expandOrCollapseAll$.value);
        this._expandOrCollapseAll$
            .pipe(takeUntil(this.#destroy$), distinctUntilChanged())
            .subscribe(this.expandOrCollapseAll$);
    }
    ngOnDestroy() {
        this.#destroy$.next();
        this.#destroy$.complete();
        this.LprManagementService.setSelectedWorkflow(null);
        this.LprManagementService.setSelectedOrg(null);
    }
    onOrgNodeSelected(node) {
        this.orgForNewWorkflow = node.data;
    }
    onWorkflowNodeSelected(node) {
        if (!this.LprManagementService.isEditableWorkflow(node.data)) {
            const editingWorkflow = this.LprManagementService.cloneForEdit(node.data);
            node.data = editingWorkflow;
        }
        this.orgForNewWorkflow = node.data.org;
        this.LprManagementService.setSelectedWorkflow(node.data);
    }
    expandAll() {
        this._expandOrCollapseAll$.next(true);
    }
    collapseAll() {
        this._expandOrCollapseAll$.next(false);
    }
    openNew() {
        const org = this.orgForNewWorkflow;
        if (org) {
            const newWorkflow = new LprWorkflow({ org }, true);
            this.LprManagementService.setSelectedWorkflow(newWorkflow);
        }
    }
};
LPRManagementComponent = __decorate([
    Component({
        selector: 'lpr-management',
        standalone: true,
        imports: [CommonModule, ButtonModule, SplitterModule, LPRWorkflowListComponent, LprWorkflowComponent, ToastModule],
        template: __NG_CLI_RESOURCE__0,
        encapsulation: ViewEncapsulation.None,
    })
], LPRManagementComponent);
export { LPRManagementComponent };
